export const PAIRING_STATUS_PAIRED = 'paired';

export const PAIRING_STATUS_PENDING = 'pending';

export const REFRESH_AUTH = 'refreshAuth';

export const REQUIRE_AUTH = 'requireAuth';
